import { render, staticRenderFns } from "./SelectTaskStatus.vue?vue&type=template&id=daaf068c&lang=pug&"
import script from "./SelectTaskStatus.vue?vue&type=script&lang=js&"
export * from "./SelectTaskStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports